import { useState } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_MANUAL_SYSTEM, UPDATE_SYSTEM_CONFIGS } from "../../../../../apis/settingsApis/access-apis/accessApis";

export const useSystemActions = (refetchCriticalSystems) => {
  const [snackbarInfo, setSnackbarInfo] = useState(null);
  const [archivingSystemId, setArchivingSystemId] = useState(null);
  const [createManualSystem, { loading: loadingCreateManualSystem }] = useMutation(CREATE_MANUAL_SYSTEM);
  const [updateSystemConfigs] = useMutation(UPDATE_SYSTEM_CONFIGS);

  const handleArchiveSystem = async (system) => {
    if (system.isGroupHeader) {
      return;
    }
    
    setArchivingSystemId(system.id);
    try {
      await updateSystemConfigs({
        variables: {
          input: [{
            id: parseInt(system.id),
            is_review_active: !system.is_review_active
          }]
        },
      });

      setSnackbarInfo({
        message: system.is_review_active 
          ? "Account archived successfully!" 
          : "Account unarchived successfully!",
        vertical: "top",
        horizontal: "right",
      });
      
      await refetchCriticalSystems();
    } catch (error) {
      console.error("Archive error:", error);
      setSnackbarInfo({
        message: "Failed to archive/unarchive account. Please try again.",
        vertical: "top",
        horizontal: "right",
        severity: "error",
      });
    } finally {
      setArchivingSystemId(null);
    }
  };

  const manualCreateCriticalSystem = async (systemData) => {
    const apiData = {
      label: systemData.name || systemData.label,
      category: systemData.category || systemData.type || 'manual',
      system_admin: systemData.system_admin,
      is_critical: systemData.is_critical,
      review_cycle: systemData.review_cycle,
      account_label: systemData.account_label || null,
      users: (systemData.users || []).map(user => ({
        name: user.name,
        email: user.email,
        role: user.role
      })),
    };
        
    try {
      const result = await createManualSystem({
        variables: {
          input: apiData,
        },
      });
      
      if (result.data?.createManualSystem?.success) {
        refetchCriticalSystems();
        setSnackbarInfo({
          message: "Critical account created successfully!",
          vertical: "top",
          horizontal: "right",
        });
        return true;
      } else {
        setSnackbarInfo({
          message: "Failed to create critical account. Please try again.",
          vertical: "top",
          horizontal: "right",
        });
        return false;
      }
    } catch (error) {
      console.error("Failed to create critical account:", error);
      setSnackbarInfo({
        message: "Failed to create critical account. Please try again.",
        vertical: "top",
        horizontal: "right",
      });
      return false;
    }
  };

  return {
    snackbarInfo,
    setSnackbarInfo,
    archivingSystemId,
    loadingCreateManualSystem,
    handleArchiveSystem,
    manualCreateCriticalSystem,
  };
};

